<app-header></app-header>
<app-navbar></app-navbar>
<div class="d-flex">
    <aside role="complementary" [attr.aria-label]="'asideDescription' | translate">
        <app-sidebar [items]="links" [subItems]="subLinks"></app-sidebar>
    </aside>
    <main class="ps-5 w-100">
        <div class="row" [formGroup]="filterParams">
            <div class="modelinput col-4">
                <label>{{ 'model.choseTaxModel' | translate }}</label>
                <select class="form-select" aria-label="listRateModelDto" formControlName="taxModel">
                    <option [value]="" hidden></option>
                    <option *ngFor="let model of this.modelResponse.listRateModelDto" [value]=" model.idRateModel">
                        {{(('academicTaxes.' + model.typology) | translate)+ ' - ' +
                        model.rateModelTraductionDto?.[0]?.shortDescription + ' - ' +
                        model.codeRateModel}}
                    </option>
                </select>
            </div>
        </div>
        <div *ngIf="filterParams.get('taxModel')?.value" class=" row mb-3">
            <div class="text-end d-flex align-items-center col-12 mt-2 justify-content-between">
                <h2 class="mb-3 textformat"> {{'sidebar.academicTaxes' | translate}}</h2>
                <button type="button" class="btn custombutton" (click)="newModel()">{{
                    'academicTaxes.newRegister' |
                    translate}}</button>
            </div>
        </div>

        <div *ngIf="hasAcademicFees">
            <fieldset>
                <table id="table1" class="table" role="grid" [attr.aria-label]="'model.choseTaxModel' | translate">
                    <thead>
                        <tr role="row">
                            <th scope="col"><span class="visually-hidden">{{ 'seleccionarFila' | translate }}</span>
                            </th>
                            <th scope="col">{{'academicTaxes.modelType' | translate}}</th>
                            <th scope="col">{{'academicTaxes.registrationNumber' | translate}}</th>
                            <th scope="col">{{'academicTaxes.taxType' | translate}}</th>
                            <th scope="col">{{'academicTaxes.description' | translate}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of this.academicFeeResponse.listAcademicFeeDto"
                            [ngClass]="{ 'resaltado': selectedRowId === row.idOwnAcademicFee }" role="row">
                            <td role="gridcell">
                                <input type="radio" [id]="'radio-' + row.idOwnAcademicFee" name="checkbox1"
                                    [checked]="selectedRowId === row.idOwnAcademicFee" (click)="toggleRow(row)" />
                                <label [for]="'radio-' + row.idOwnAcademicFee" class="visually-hidden">
                                    {{ "seleccionarFilaCon" | translate }}:
                                    {{ 'academicTaxes.modelType' | translate }} {{ ('academicTaxes.' +
                                    row.rateModelDto?.typology) | translate }},
                                    {{ 'academicTaxes.registrationNumber' | translate }} {{ row.numberOfRegistration ===
                                    '7'
                                    ? ('cualquiera' | translate) : row.numberOfRegistration }},
                                    {{ 'academicTaxes.taxType' | translate }} {{ row.rateType === 'N' ?
                                    ('academicTaxes.normal' | translate) : 'N/A' }},
                                    {{ 'academicTaxes.description' | translate }} {{
                                    row.ownAcademicFeeTraductionDto?.[0]?.description || 'N/A' }}
                                </label>
                            </td>
                            <td role="gridcell">
                                <span>{{ (('academicTaxes.' + row.rateModelDto?.typology) | translate) }}</span>
                            </td>
                            <td role="gridcell">
                                <span *ngIf="row.numberOfRegistration == '7'">{{'cualquiera' | translate}}</span>
                                <span *ngIf="row.numberOfRegistration != '7'">{{ row.numberOfRegistration }}</span>
                            </td>
                            <td role="gridcell">
                                <span *ngIf="row.rateType=='N'">{{ 'academicTaxes.normal' | translate}}</span>
                            </td>
                            <td role="gridcell">
                                <span>{{ row.ownAcademicFeeTraductionDto?.[0]?.description }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </fieldset>

            <!-- Controles de paginación -->
            <div class="mt-2" *ngIf="this.academicFeeResponse.pageDto">
                <app-paginator [isStart]="this.academicFeeResponse.pageDto.start"
                    [isEnd]="this.academicFeeResponse.pageDto.end"
                    [currentPage]="this.academicFeeResponse.pageDto.currentPage"
                    [totalPages]="this.academicFeeResponse.pageDto.pages"
                    [numberRecord]="this.academicFeeResponse.pageDto.records"
                    [sizePage]="this.academicFeeResponse.pageDto.pageSize">
                </app-paginator>
            </div>

        </div>
        <div *ngIf="selectedRowId || isCreate">
            <div>
                <div class="separator mt-5"></div>
                <h2 class="mb-3 mt-4 textformat"> {{'academicTaxes.academicServices' |
                    translate}}</h2>
            </div>
            <form [formGroup]="academicservicesForm">
                <div class="row ">
                    <div class="mb-3 col-4">
                        <label for="feeType">{{'academicTaxes.taxType' | translate}}<span>
                                *</span></label>
                        <select class="form-select" formControlName="feeType" name="feeType" id="feeType">
                            <option [value]="'N'">{{ 'academicTaxes.normal' | translate}}</option>
                        </select>
                    </div>
                    <div class="mb-3 col-4">
                        <label for="numberOfRegistration">{{'academicTaxes.registrationNumber' | translate}}<span>
                                *</span></label>
                        <select class="form-select" formControlName="numberOfRegistration" id="numberOfRegistration"
                            name="numberOfRegistration">
                            <option [value]='null'></option>
                            <option value="1" *ngIf="controlNumberOfRegistration('1') || !isCreate">1</option>
                            <option value="2" *ngIf="controlNumberOfRegistration('2') || !isCreate">2</option>
                            <option value="3" *ngIf="controlNumberOfRegistration('3') || !isCreate">3</option>
                            <option value="4" *ngIf="controlNumberOfRegistration('4') || !isCreate">4</option>
                            <option value="5" *ngIf="controlNumberOfRegistration('5') || !isCreate">5</option>
                            <option value="6" *ngIf="controlNumberOfRegistration('6') || !isCreate">6</option>
                            <option value="7">{{ 'cualquiera' | translate }}</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mb-3">
                        <label for="descripcionCat">{{'model.descriptionCat' | translate}}<span>
                                *</span></label>
                        <input type="text" name="descripcionCat" id="descripcionCat" class="form-control"
                            placeholder="Ingrese la descripción en catalán" formControlName="descripcionCat" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mb-3">
                        <label for="descripcionCast">{{'model.descriptionCast' | translate}}<span>
                                *</span></label>
                        <input type="text" name="descripcionCast" id="descripcionCast" class="form-control"
                            placeholder="Ingrese la descripción en castellano" formControlName="descripcionCast" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mb-3">
                        <label for="descripcionIng">{{'model.descriptionEng' | translate}}<span>
                                *</span></label>
                        <input type="text" id="descripcionIng" name="descripcionIng" class="form-control"
                            placeholder="Ingrese la descripción en inglés" formControlName="descripcionIng" />
                    </div>
                </div>
                <div class="row d-flex">
                    <div class="col-12 mt-4">
                        <button type="button" class="btn cancelbutton me-2" (click)="onCancel()">Cancelar</button>
                        <button type="button" class="btn custombutton" (click)="saveAcademicServices()">
                            {{ !isCreate ? ('academicTaxes.modify' | translate ) : 'academicTaxes.save' | translate
                            }}</button>
                    </div>
                </div>
                <app-alert-component [isDanger]="isError" [isOk]="isCreated" [message]="errorMessage"
                    (close)="this.isCreated = this.isError = false"></app-alert-component>
            </form>
        </div>
        <div *ngIf="selectedRowId">
            <div>
                <div class="separator mt-4"></div>
                <div class="row mt-4 mb-3">
                    <h2 class="mb-3 textformat col-8"> {{'academicTaxes.academicPrices' |
                        translate}}</h2>
                    <div class="text-end d-flex align-items-center col-4 mt-2 justify-content-end">
                        <button type="button" class="btn custombutton " id="clone" (click)="clone()"
                            [disabled]="!selectedAcademicPriceId">{{'Clonar' | translate }}</button>
                        <button type="button" class="btn custombutton ms-2"
                            (click)="newRegister()">{{'academicTaxes.newRegister' | translate}}</button>
                    </div>
                </div>
            </div>

            <div>
                <fieldset>
                    <table id="table1" class="table" role="grid"
                        [attr.aria-label]="'academicTaxes.academicPrices' | translate">
                        <thead>
                            <tr role="row">
                                <th scope="col">
                                    <span class="visually-hidden">{{'seleccionar' | translate}}</span>
                                </th>
                                <th scope="col">{{'academicTaxes.price' | translate}}</th>
                                <th scope="col">{{'academicTaxes.firstInstallment' | translate}}</th>
                                <th scope="col">{{'academicTaxes.registrationDate' | translate}}</th>
                                <th scope="col">{{'academicTaxes.endDate' | translate}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of this.academicFeePriceResponse.listAcademicFeePriceDto; let i = index"
                                [ngClass]="{ 'resaltado': selectedAcademicPriceId === row.idOwnAcademicFeePrice }"
                                role="row">
                                <td role="gridcell">
                                    <input [ariaLabel]="row.idOwnAcademicFeePrice" type="radio"
                                        [id]="'radio-' + row.idOwnAcademicFeePrice" name="checkbox2"
                                        [checked]="selectedAcademicPriceId === row.idOwnAcademicFeePrice"
                                        (click)="toggleRowFeePrice(row)" />
                                    <label [for]="'radio-' + row.idOwnAcademicFeePrice" class="visually-hidden">
                                        {{ "seleccionarFilaCon" | translate }}:
                                        {{ 'academicTaxes.price' | translate }} {{ row.price }},
                                        {{ 'academicTaxes.firstInstallment' | translate }} {{ row.firstTermPayment ?
                                        ('academicTaxes.S' | translate) : ('academicTaxes.N' | translate) }},
                                        {{ 'academicTaxes.registrationDate' | translate }} {{ row.startDate |
                                        date:'dd/MM/yyyy' }},
                                        {{ 'academicTaxes.endDate' | translate }} {{ row.endDate | date:'dd/MM/yyyy' }}
                                    </label>
                                </td>
                                <td role="gridcell">{{ row.price }}</td>
                                <td role="gridcell">{{ row.firstTermPayment ? ('academicTaxes.S' | translate) :
                                    ('academicTaxes.N' | translate) }}</td>
                                <td role="gridcell">{{ row.startDate | date:'dd/MM/yyyy' }}</td>
                                <td role="gridcell">{{ row.endDate | date:'dd/MM/yyyy' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </fieldset>

                <!-- Controles de paginación -->
                <div class="mt-2" *ngIf="this.academicFeePriceResponse.pageDto">
                    <app-paginator [isStart]="this.academicFeePriceResponse.pageDto.start"
                        [isEnd]="this.academicFeePriceResponse.pageDto.end"
                        [currentPage]="this.academicFeePriceResponse.pageDto.currentPage"
                        [totalPages]="this.academicFeePriceResponse.pageDto.pages"
                        [numberRecord]="this.academicFeePriceResponse.pageDto.records"
                        [sizePage]="this.academicFeePriceResponse.pageDto.pageSize">
                    </app-paginator>
                </div>
                <div *ngIf="selectedAcademicPriceId || isCreateFeePrice || isClone">
                    <div>
                        <div class="separator mt-5"></div>
                        <h2 class="mb-3 mt-4 textformat"> {{'academicTaxes.academicPrices'
                            | translate}}</h2>
                    </div>
                    <form [formGroup]="formAcademicPrices">
                        <div class="row">
                            <!-- Fecha de alta -->
                            <div class="mb-3 col-6">
                                <label for="startDate">{{'academicTaxes.registrationDate' |translate}}<span>
                                        *</span></label>
                                <input type="date" class="form-control" id="startDate" name="startDate"
                                    formControlName="startDate" />
                            </div>

                            <!-- Fecha de baja -->
                            <div class="mb-3 col-6">
                                <label for="endDate">{{'academicTaxes.endDate' |translate}}</label>
                                <input type="date" class="form-control" id="endDate" name="endDate"
                                    formControlName="endDate" />
                            </div>
                        </div>

                        <div class="row">
                            <!-- Primer plazo -->
                            <div class="mb-3 col-6 ">
                                <label for="firstTermPayment" class="form-label">{{'academicTaxes.firstInstallment'
                                    |
                                    translate}}<span>
                                        *</span></label>
                                <select class="form-select" id="firstTermPayment" name="firstTermPayment"
                                    formControlName="firstTermPayment">
                                    <option value="true">{{'academicTaxes.S' | translate}}</option>
                                    <option value="false">{{'academicTaxes.N' | translate}}</option>
                                </select>
                            </div>

                            <!-- Precio -->
                            <div class="mb-3 col-6">
                                <label for="price" class="form-label">{{'academicTaxes.price' |
                                    translate}}<span>
                                        *</span></label>
                                <input type="number" class="form-control" id="price" name="price"
                                    formControlName="price" [min]="0" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="mb-3 col-6">
                                <label for="idVatPattern" class="form-label">{{'academicTaxes.ivaPattern' |
                                    translate}}<span>
                                        *</span></label>
                                <select class="form-select" id="idVatPattern" name="idVatPattern"
                                    formControlName="idVatPattern">
                                    <option *ngFor="let vat of listVatPattern" [value]="vat.idVatPattern">
                                        {{ vat.vatPatternTraductionDto?.[0]?.description }}
                                    </option>

                                </select>
                            </div>
                        </div>
                        <div class="row d-flex">
                            <div class="col-12 mt-4">
                                <button type="button" class="btn cancelbutton"
                                    (click)="selectedAcademicPriceId = null; isClone = isCreateFeePrice = false ">{{'academicTaxes.cancel'
                                    |
                                    translate}}</button>
                                <button type="button" class="btn custombutton ms-2" (click)="saveRecord()"> {{
                                    (selectedAcademicPriceId && !isClone) ? ('academicTaxes.modify' | translate ) :
                                    'academicTaxes.save' | translate
                                    }}</button>
                            </div>
                        </div>
                    </form>
                </div>
                <app-alert-component [isDanger]="isErrorFeePrice" [isOk]="isCreatedFeePrice" [message]="errorMessage"
                    (close)="this.isCreatedFeePrice = this.isErrorFeePrice = false"></app-alert-component>
            </div>
        </div>


        <div *ngIf="selectedRowId">
            <div>
                <div class="separator mt-4"></div>
                <div class="row mt-4 mb-3">
                    <h2 class="mb-3 textformat col-8"> {{'academicTaxes.academicDiscounts'
                        | translate}}</h2>
                    <div class="text-end d-flex align-items-center col-4 mt-2 justify-content-end">
                        <button type="button" class="btn custombutton"
                            (click)="newAcademicDiscount()">{{'academicTaxes.newRegister' | translate}}</button>
                    </div>
                </div>
            </div>

            <div>
                <fieldset>
                    <table id="table2" class="table" role="grid"
                        [attr.aria-label]="'academicTaxes.academicDiscounts' | translate">
                        <thead>
                            <tr role="row">
                                <th scope="col">
                                    <span class="visually-hidden">{{'seleccionar' | translate}}</span>
                                </th>
                                <th scope="col">{{'discount.codeDiscount' | translate}}</th>
                                <th scope="col">{{'academicTaxes.discount' | translate}}</th>
                                <th scope="col">{{'typesVat.percentage' | translate}}</th>
                                <th scope="col">{{'academicTaxes.import' | translate}}</th>
                                <th scope="col">{{'academicTaxes.order' | translate}}</th>
                                <th scope="col">{{'academicTaxes.registrationDate' | translate}}</th>
                                <th scope="col">{{'academicTaxes.endDate' | translate}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of this.ownRateDiscountResponse.IdOwnRateDiscountDto; let i = index"
                                [ngClass]="{ 'resaltado': selectedOwnRateDiscountId === row.idOwnRateDiscount }"
                                role="row">
                                <td role="gridcell">
                                    <input [ariaLabel]="row.idOwnRateDiscount" type="radio"
                                        [id]="'radio-' + row.idOwnRateDiscount" name="checkbox3"
                                        [checked]="selectedOwnRateDiscountId === row.idOwnRateDiscount"
                                        (click)="toggleRowAcademicDiscount(row)" />
                                    <label [for]="'radio-' + row.idOwnRateDiscount" class="visually-hidden">
                                        {{ "seleccionarFilaCon" | translate }}:
                                        {{ 'discount.codeDiscount' | translate }} {{
                                        row.generalDiscountCatalogDto?.discountCode }},
                                        {{ 'academicTaxes.discount' | translate }}
                                        <ng-container
                                            *ngFor="let desc of row.generalDiscountCatalogDto?.generalDiscountCatalogTraductionDto">
                                            <span *ngIf="desc.languageDto?.code === currentLanguage">{{
                                                desc.discountDescription }}</span>
                                        </ng-container>,
                                        {{ 'typesVat.percentage' | translate }} {{ row.discountPercentage }},
                                        {{ 'academicTaxes.import' | translate }} {{ row.fixedDiscountAmount }},
                                        {{ 'academicTaxes.order' | translate }} {{ row.discountOrderNumber }},
                                        {{ 'academicTaxes.registrationDate' | translate }} {{ row.startDate |
                                        date:'dd/MM/yyyy' }},
                                        {{ 'academicTaxes.endDate' | translate }} {{ row.endDate | date:'dd/MM/yyyy' }}
                                    </label>
                                </td>
                                <td role="gridcell">{{ row.generalDiscountCatalogDto?.discountCode }}</td>
                                <td role="gridcell">
                                    @for (desc of row.generalDiscountCatalogDto?.generalDiscountCatalogTraductionDto;
                                    track
                                    $index) {
                                    <span
                                        *ngIf="desc.languageDto?.code==currentLanguage">{{desc.discountDescription}}</span>
                                    }
                                </td>
                                <td role="gridcell">{{ row.discountPercentage }}</td>
                                <td role="gridcell">{{ row.fixedDiscountAmount }}</td>
                                <td role="gridcell">{{ row.discountOrderNumber }}</td>
                                <td role="gridcell">{{ row.startDate | date:'dd/MM/yyyy' }}</td>
                                <td role="gridcell">{{ row.endDate | date:'dd/MM/yyyy' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </fieldset>
                <!-- Controles de paginación -->
                <div class="mt-2" *ngIf="this.ownRateDiscountResponse.pageDto">
                    <app-paginator [isStart]="this.ownRateDiscountResponse.pageDto.start"
                        [isEnd]="this.ownRateDiscountResponse.pageDto.end"
                        [currentPage]="this.ownRateDiscountResponse.pageDto.currentPage"
                        [totalPages]="this.ownRateDiscountResponse.pageDto.pages"
                        [numberRecord]="this.ownRateDiscountResponse.pageDto.records"
                        [sizePage]="this.ownRateDiscountResponse.pageDto.pageSize">
                    </app-paginator>
                </div>

                <div *ngIf="selectedOwnRateDiscountId || isCreatedOwnRateDiscount">
                    <div>
                        <div class="separator mt-5"></div>
                        <h2 class="mb-3 mt-4 textformat">
                            {{'academicTaxes.academicDiscounts' | translate}}</h2>
                    </div>
                    <form [formGroup]="formDiscount">
                        <div class="row">
                            <div class="mb-3 col-6 ">
                                <label for="idGeneralDiscountCatalog" class="form-label">{{'academicTaxes.discount'
                                    |translate}}<span>
                                        *</span></label>
                                <select class="form-select" id="idGeneralDiscountCatalog"
                                    name="idGeneralDiscountCatalog" formControlName="idGeneralDiscountCatalog"
                                    (change)="changeDescompte()">
                                    @for (discount of this.discountRateModelResponse.discountRateModelCatalogDto; track $index) {
                                        @if(isDiscountValid(discount.generalDiscountCatalogDto?.discountCode) || !isCreatedOwnRateDiscount) {
                                    <option
                                        [value]="discount.discountRateModelCatalogPkDto?.generalDiscountCatalogId">
                                        <span>{{discount.generalDiscountCatalogDto?.discountCode}} - <span>{{
                                                getDiscountDescription(discount.generalDiscountCatalogDto?.idGeneralDiscountCatalog)
                                                }}</span>
                                        </span>
                                    </option>
                                }
                                }
                                </select>
                            </div>
                            <div class="mb-3 col-6">
                                <label for="discountOrderNumber" class="form-label">{{'academicTaxes.order' |
                                    translate}}<span>
                                        *</span></label>
                                <input type="number" class="form-control" id="discountOrderNumber"
                                    name="discountOrderNumber" formControlName="discountOrderNumber" />
                                <span *ngIf="message.length>0">{{'messageOrder' | translate}}
                                    <strong>{{message[0].generalDiscountCatalogDto.discountCode}}</strong> </span>

                            </div>
                            <div class="mb-3 col-6">
                                <label for="importType" class="form-label">{{'typesVat.type' |translate}}</label>
                                <select class="form-select" formControlName="importType" name="importType"
                                    id="importType">
                                    <option value="I">{{'academicTaxes.import' |translate}}</option>
                                    <option value="P">{{'typesVat.percentage' |translate}}</option>
                                </select>
                            </div>
                            @if (formDiscount.get('importType')?.value=='I') {
                            <div class="mb-3 col-6">
                                <label for="fixedDiscountAmount" class="form-label">{{'academicTaxes.import'
                                    |translate}}<span>
                                        *</span></label>
                                <input type="number" class="form-control" id="fixedDiscountAmount"
                                    name="fixedDiscountAmount" formControlName="fixedDiscountAmount" [min]="0" />
                            </div>
                            }
                            @if (formDiscount.get('importType')?.value=='P') {
                            <div class="mb-3 col-6">
                                <label for="discountPercentage" class="form-label">{{'typesVat.percentage'|
                                    translate}}<span>
                                        *</span></label>
                                <input type="number" class="form-control" id="discountPercentage"
                                    name="discountPercentage" formControlName="discountPercentage" [min]="0"
                                    [max]="100" />
                            </div>
                            }
                            <div class="mb-3 col-6">
                                <label for="registrationDate" class="form-label">{{'academicTaxes.registrationDate'
                                    |
                                    translate}}<span>
                                        *</span></label>
                                <input type="date" class="form-control" id="registrationDate" name="registrationDate"
                                    formControlName="startDate" />
                            </div>

                            <!-- Fecha de baja -->
                            <div class="mb-3 col-6">
                                <label for="endDate1" class="form-label">{{'academicTaxes.endDate'
                                    |translate}}</label>
                                <input type="date" class="form-control" id="endDate1" name="endDate1"
                                    formControlName="endDate" />
                            </div>
                        </div>
                        <div class="row d-flex">
                            <div class="col-12 mt-4">
                                <button type="button" class="btn cancelbutton"
                                    (click)="this.selectedOwnRateDiscountId = null; this.formDiscount.reset(); this.isCreatedOwnRateDiscount = false">{{'academicTaxes.cancel'
                                    |translate}}</button>
                                <button *ngIf="!selectedOwnRateDiscountId" type="button" class="btn custombutton ms-2"
                                    (click)="saveOwnRateDiscount()"> {{
                                    'academicTaxes.save' | translate
                                    }}</button>
                                <button *ngIf="selectedOwnRateDiscountId" type="button" class="btn custombutton ms-2"
                                    (click)="saveOwnRateDiscount()"> {{
                                    'academicTaxes.modify' | translate
                                    }}</button>
                            </div>
                        </div>

                    </form>
                </div>
                <app-alert-component [isDanger]="isErrorOwnRateDiscount" [isOk]="isCreateOwnRateDiscount"
                    [message]="errorMessage"
                    (close)="this.isCreateOwnRateDiscount = this.isErrorOwnRateDiscount = false"></app-alert-component>
            </div>
        </div>
    </main>
</div>